import { NavigationVariant } from '~/Features/Navigation/NavigationVariant.csharp';

export const resolveNavElementsColor = (
    variant: NavigationVariant,
    isScrollLocked: boolean,
    isHeaderSticky: boolean,
    isSearchOpened: boolean,
    isMobile: boolean
) =>
    variant === NavigationVariant.TransparentLight &&
    !isScrollLocked &&
    !isHeaderSticky &&
    !(isSearchOpened && isMobile)
        ? 'light'
        : 'dark';
